module.exports = __webpack_public_path__ + "img/symbol_5.1d35f5ba.png";